<script>
  import { fade, fly } from 'svelte/transition';
  import { Icon, X } from 'svelte-hero-icons';

  import LogoS from '$lib/assets/images/logos/logo.svg';

  export let toggle = false;
  export let toggleClose = function () {};
  export let menus = [];
</script>

{#if toggle}
  <div in:fly="{{duration: 50}}" out:fade>
    <div class="absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden">
      <div class="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
        <div class="pt-5 pb-6 px-5">
          <div class="flex items-center justify-between">
            <div>
              <img class="h-10 w-auto" src={LogoS} alt="Logo">
            </div>
            <div class="-mr-2">
              <button type="button" class="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-orange-500" on:click={toggleClose}>
                <span class="sr-only">关闭菜单</span>
                <!-- Heroicon name: outline/x -->
                <Icon src={X} class="h-6 w-6" />
              </button>
            </div>
          </div>
        </div>
        <!-- menu -->
        <div class="py-6 px-5 space-y-6">
          <div class="grid grid-cols-2 gap-y-4 gap-x-8">
            {#each menus as menu}
              <a href={menu.url} class="inline-flex items-center text-base text-gray-500 hover:text-gray-700" on:click={toggleClose}>
                {#if menu.icon}
                  <Icon src={menu.icon} class="h-5 w-5 mr-1" />
                {/if}
                {menu.name}
              </a>
            {/each}
          </div>
          <!-- login -->
          <!-- <div>
            <a href="/auth/register" class="w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-orange-600 hover:bg-orange-700">注册</a>
            <p class="mt-6 text-center text-base font-medium text-gray-500">
              已有账号？
              <a href="/auth/login" class="text-orange-600 hover:text-orange-500">登录</a>
            </p>
          </div> -->
        </div>
      </div>
    </div>
  </div>
{/if}
